/* 47X · MYSTERY BOX DSX47 · selector de experiencia en PDP · ES5
   ─────────────────────────────────────────────────────────────────────────
   El marcado lo pinta Liquid: aquí solo vive el estado. Así no hay salto de
   layout ni una PDP que dependa del JS para verse completa.

   Se entiende con el upsell del carrito (emp47) por la MISMA llave de sesión
   `emp47:fuera`. Si el cliente elige ESTÁNDAR aquí, esa llave queda puesta y
   la bolsa ya no le vuelve a ofrecer el empaque sola. Si elige PREMIUM, se
   limpia. Sin eso, elegir estándar y que la bolsa te lo agregara de vuelta
   sería exactamente el cargo escondido que no queremos.
*/
(function () {
  'use strict';

  var raiz = document.querySelector('[data-mxp47]');
  if (!raiz) return;

  var cfg;
  try { cfg = JSON.parse(document.querySelector('[data-mxp47-cfg]').textContent); }
  catch (e) { return; }

  var form = document.querySelector('#mysx47-form');
  var ctaTxt = document.querySelector('[data-mysx-ctatext]');
  var stickyBtn = document.querySelector('[data-mysx-stickybtn]');
  var msiCaja = raiz.querySelector('[data-mxp47-msi]');
  var opciones = raiz.querySelectorAll('.mxp47__opt');
  var radios = raiz.querySelectorAll('input[name="mxp47-exp"]');
  var ocupado = false;
  var vistoYa = false;

  /* Respeta el formato de dinero de la tienda ("$ 1,499", con espacio).
     Antes lo escribía a mano y la tarjeta decía $1,719 mientras el resto de
     la página decía $ 1,719. Detalle chico que se lee como descuido. */
  function dinero(cent, forzarDec) {
    var n = (Number(cent) || 0) / 100;
    var f = (cfg && cfg.formato) || '${{amount}}';
    var conDec = forzarDec || (n % 1 !== 0);
    return f.replace(/\{\{\s*(\w+)\s*\}\}/g, function (todo, k) {
      var coma = k.indexOf('comma_separator') !== -1;
      /* como money_without_trailing_zeros: los .00 no se pintan */
      var s = n.toFixed(conDec ? 2 : 0);
      var p = s.split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, coma ? '.' : ',');
      return p.length > 1 ? p[0] + (coma ? ',' : '.') + p[1] : p[0];
    });
  }
  function evento(nombre, extra) {
    try {
      window.dataLayer = window.dataLayer || [];
      var d = { event: nombre, item_name: cfg.caja_nombre, currency: cfg.moneda || 'MXN' };
      if (extra) { for (var k in extra) { if (Object.prototype.hasOwnProperty.call(extra, k)) d[k] = extra[k]; } }
      window.dataLayer.push(d);
    } catch (e) {}
  }
  function marcaFuera(v) {
    try { v ? sessionStorage.setItem('emp47:fuera', '1') : sessionStorage.removeItem('emp47:fuera'); } catch (e) {}
  }

  function elegida() {
    for (var i = 0; i < radios.length; i++) { if (radios[i].checked) return radios[i].value; }
    return 'std';
  }
  function precioCaja() {
    /* la talla puede traer precio propio · nunca asumimos el de la primera */
    var sel = form ? form.querySelector('input[name="id"]:checked') : null;
    var id = sel ? sel.value : (cfg.variante_defecto || '');
    if (cfg.precios && cfg.precios[id] != null) return cfg.precios[id];
    return cfg.caja_precio;
  }
  function hayTalla() {
    if (!form) return false;
    var grupo = form.querySelector('[data-mysx-sizes]');
    if (!grupo) return true;                       /* producto de una sola variante */
    return !!grupo.querySelector('input[name="id"]:checked');
  }

  /* ── pintado ────────────────────────────────────────────────────────── */
  function pinta() {
    var modo = elegida();
    var base = precioCaja();
    var total = modo === 'premium' ? base + cfg.empaque_precio : base;

    for (var i = 0; i < opciones.length; i++) {
      var on = opciones[i].getAttribute('data-mxp47-opt') === modo;
      opciones[i].classList.toggle('is-on', on);
    }

    if (msiCaja && cfg.msi_n > 0) {
      msiCaja.innerHTML = cfg.msi_n + ' MSI de <b>' + dinero(total / cfg.msi_n, true) + '</b>';
      msiCaja.hidden = false;
    } else if (msiCaja) { msiCaja.hidden = true; }

    /* el CTA del tema se reescribe solo al elegir talla: lo volvemos a poner */
    var txt = hayTalla()
      ? (modo === 'premium' ? cfg.cta_premium : cfg.cta_std).replace('{precio}', dinero(total))
      : cfg.cta_sin_talla;
    if (ctaTxt) ctaTxt.textContent = txt;
    if (stickyBtn) {
      var st = stickyBtn.querySelector('span') || stickyBtn;
      st.textContent = txt;
    }
  }

  /* ── selección ──────────────────────────────────────────────────────── */
  for (var r = 0; r < radios.length; r++) {
    radios[r].addEventListener('change', function () {
      var modo = elegida();
      marcaFuera(modo !== 'premium');
      evento(modo === 'premium' ? 'premium_experience_selected' : 'standard_experience_selected',
             { value: (modo === 'premium' ? precioCaja() + cfg.empaque_precio : precioCaja()) / 100 });
      pinta();
    });
  }
  /* la talla cambia el precio y además el tema reescribe el CTA */
  if (form) {
    form.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') setTimeout(pinta, 0);
    });
  }

  /* ── agregar ────────────────────────────────────────────────────────── */
  function agrega(items) {
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.ok ? r.json() : null; });
  }
  function yaTieneEmpaque() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        for (var i = 0; i < c.items.length; i++) {
          if (String(c.items[i].variant_id) === String(cfg.empaque)) return true;
        }
        return false;
      }).catch(function () { return false; });
  }

  if (form && cfg.abrir_bolsa) {
    form.addEventListener('submit', function (ev) {
      if (!hayTalla()) return;                 /* el guard del tema ya avisa */
      ev.preventDefault();
      if (ocupado) return;
      ocupado = true;

      var sel = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
      var idCaja = sel ? Number(sel.value) : Number(cfg.variante_defecto);
      var modo = elegida();

      var paso = modo === 'premium'
        ? yaTieneEmpaque().then(function (tiene) {
            var items = [{ id: idCaja, quantity: 1 }];
            /* una sola unidad de empaque, por más veces que se agregue caja */
            if (!tiene) items.push({ id: Number(cfg.empaque), quantity: 1 });
            return agrega(items);
          })
        : agrega([{ id: idCaja, quantity: 1 }]);

      paso.then(function () {
        evento(modo === 'premium' ? 'premium_experience_added' : 'standard_experience_added',
               { value: (modo === 'premium' ? precioCaja() + cfg.empaque_precio : precioCaja()) / 100 });
        try {
          window.dispatchEvent(new CustomEvent('cart47:refresh'));
          window.dispatchEvent(new CustomEvent('cart47:open'));
        } catch (e) {}
        ocupado = false;
      }).catch(function () {
        ocupado = false;
        form.submit();                          /* si el AJAX falla, el form nativo responde */
      });
    }, false);
  }

  /* ── arranque ───────────────────────────────────────────────────────── */
  if (cfg.pre === 'premium') { marcaFuera(false); } else { marcaFuera(true); }
  pinta();

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (ent) {
      for (var i = 0; i < ent.length; i++) {
        if (ent[i].isIntersecting && !vistoYa) {
          vistoYa = true;                       /* una sola vez por carga */
          evento('premium_experience_view');
          io.disconnect();
        }
      }
    }, { threshold: 0.4 });
    io.observe(raiz);
  }
})();
